import Board from './Board';

export * from './Board';
export default Board;
